<template>
    <div class="account-details-orders-tab tab-contents">
        <PageLoadingSpinner v-if="loading"
                            color="light"
                            lang="MANAGE_ACCOUNT.LOADING_ORDERS" />
        <NoResults v-else-if="totalItems < 1"
                   icon="fa-solid fa-file-xmark"
                   color="light"
                   lang="MANAGE_ACCOUNT.NO_ORDERS">
            <AddAccountToCartButton :account="account"
                                    button-class="mt-1 btn-info"
                                    data-analytics-id="Account Details / Orders Tab / Add Account To Cart" />
        </NoResults>
        <template v-else>
            <OrdersList :orders="visibleOrders">
                <span>
                    <AddAccountToCartButton :account="account"
                                            button-class="btn-info"
                                            data-analytics-id="Account Details / Orders Tab / Add Account To Cart" />
                </span>
            </OrdersList>

            <Pager v-model="currentPage"
                   class="mt-1"
                   :total-items="totalItems"
                   :page-size="pageSize" />
        </template>
    </div>
</template>

<script>
import AddAccountToCartButton from '@/epos/vue/pages/account-details/components/AddAccountToCartButton';
import NoResults from '@/vue/components/NoResults';
import OrdersList from '@/epos/vue/components/Orders/OrdersList';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import Pager from '@/vue/components/Pager';

export default {
    components: {
        AddAccountToCartButton,
        NoResults,
        Pager,
        OrdersList,
        PageLoadingSpinner,
    },

    props: {
        /**
         * @type {CustomerAccount}
         */
        account: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            currentPage: 1,
            pageSize: 10,
        };
    },

    computed: {
        /**
         * @returns {OrderSearchResults|null}
         */
        orderSearchResults() {
            return this.$store.state.accountDetails.currentAccountOrderSearchResults;
        },

        loading() {
            return this.$store.state.accountDetails.ordersLoading;
        },

        loaded() {
            return this.orderSearchResults !== null;
        },

        /**
         * @returns {Order[]}
         */
        visibleOrders() {
            // Return a chunk of this.memberships for the current page:
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.orderSearchResults.orders.slice(start, end);
        },

        /**
         * @returns {number}
         */
        totalItems() {
            return this.orderSearchResults.orders.length;
        },
    },
};
</script>
